import React from 'react';
import {Link, useLocation} from "react-router-dom";
import {ANIMATION_DEFAULT} from "@florian-cassagne/simple-toolbox";


function NavItem({
                   children,
                   link,
                   id = null,
                   isExternLink = false,
                   disabled = false,
                   className = '',
                   ...props
                 }) {
  let location = useLocation();

  return (
    <li className={'nav-element ease-in-out hover:text-orange-300 hover:scale-105 '
      + ((location.pathname === link) ? 'text-orange-300 ' : '')
      + ANIMATION_DEFAULT + className}
        {...props}>
      {
        isExternLink ? (
            <a href={link} className={'block px-2 sm:!px-5 py-2'}>
              {children}
            </a>
          )
          :
          <Link to={link} className={'block px-2 sm:!px-5 py-2'}>
            {children}
          </Link>

      }
    </li>
  );
}


export default NavItem;
